export default __webpack_public_path__ + "static/lava-llama-screenshot-wide-908da7da7f17d5b5de4c7ffd5d0ac3c3.png";